export interface StoreUnit {
  name: string;
  code: string;
  divisible: boolean;
}

export const STANDARD_UNITS: StoreUnit[] = [
  { name: 'Kg', code: 'KG', divisible: true },
  { name: 'gm', code: 'GM', divisible: true },
  { name: 'Ltr', code: 'LTR', divisible: true },
  { name: 'ml', code: 'ML', divisible: true },
  { name: 'Piece', code: 'PC', divisible: false },
  { name: 'Packet', code: 'PKT', divisible: false },
  { name: 'Pouch', code: 'PCH', divisible: false },
  { name: 'Bottle', code: 'BTL', divisible: false },
  { name: 'Tin', code: 'TIN', divisible: false },
  { name: 'Jar', code: 'JAR', divisible: false },
  { name: 'Dozen', code: 'DZN', divisible: false },
  { name: 'Carton', code: 'CRTN', divisible: false },
  { name: 'Bag', code: 'BAG', divisible: false },
  { name: 'Bora', code: 'BORA', divisible: false },
  { name: 'Meter', code: 'M', divisible: true }
]; 